// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__18l6L","footer":"ChangeClinic_footer__sHCxH"};